import { ReactComponent as SlideShow } from './icon.svg'

export default SlideShow
